import "./chart.css";
import {
  LineChart,
  Line,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { AdminCard } from "../../../components/ui";

// Recharts renders stroke as a raw SVG attribute, not a CSS property, so
// it can't resolve var(--admin-accent) directly - this literal must be
// kept in sync with that token's value (#5b3ff2).
const ACCENT = "#5b3ff2";
const GRID = "#edf0f5";

export default function Chart({ title, data, dataKey, grid }) {
  return (
    <AdminCard className="chart">
      <h2 className="chartTitle">{title}</h2>
      <ResponsiveContainer width="100%" aspect={4 / 1}>
        <LineChart data={data}>
          <XAxis dataKey="name" stroke="#8a90a0" fontSize={12} tickLine={false} axisLine={{ stroke: GRID }} />
          <Line type="monotone" dataKey={dataKey} stroke={ACCENT} strokeWidth={2} dot={false} />
          <Tooltip
            contentStyle={{
              border: "1px solid #edf0f5",
              borderRadius: 10,
              fontSize: 13,
              boxShadow: "0 4px 12px rgba(16,24,40,0.08)",
            }}
          />
          {grid && <CartesianGrid stroke={GRID} vertical={false} />}
        </LineChart>
      </ResponsiveContainer>
    </AdminCard>
  );
}
